import React from 'react';

const ProjectCard = ({ project }) => {
  return (
    <div className="border rounded-lg p-4 shadow-md">
      <h3 className="text-xl font-semibold mb-2">{project.title}</h3>
      <p className="text-gray-600 mb-2">{project.description.substring(0, 100)}...</p>
      <div className="flex justify-between text-sm text-gray-500">
        <span>Presupuesto: ${project.budget}</span>
        <span>Plazo: {project.timeline} semanas</span>
      </div>
      <div className="mt-4">
        <span className="bg-blue-100 text-blue-800 text-xs font-medium mr-2 px-2.5 py-0.5 rounded">
          {project.status}
        </span>
      </div>
    </div>
  );
};

export default ProjectCard;